var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8525 10.0009C18.8525 14.89 14.8892 18.8534 10 18.8534C5.1109 18.8534 1.14758 14.89 1.14758 10.0009C1.14758 5.11176 5.1109 1.14844 10 1.14844C14.8892 1.14844 18.8525 5.11176 18.8525 10.0009Z",
    fill: "#C63838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3116 5.8392L10.4532 7.69762C10.2029 7.94787 9.79708 7.94777 9.54683 7.69753L7.6885 5.8392C7.17778 5.32848 6.34986 5.32848 5.83915 5.8392C5.32853 6.34982 5.32853 7.17774 5.83924 7.68845L7.69758 9.54678C7.94782 9.79703 7.94782 10.203 7.69758 10.4532L5.83924 12.3115C5.32853 12.8223 5.32853 13.6502 5.83915 14.1608C6.34977 14.6714 7.17769 14.6714 7.68841 14.1607L9.54674 12.3024C9.79698 12.0521 10.2029 12.0521 10.4532 12.3024L12.3115 14.1607C12.8222 14.6714 13.6501 14.6714 14.1608 14.1608C14.6715 13.6501 14.6715 12.8222 14.1608 12.3115L12.3024 10.4531C12.0522 10.2029 12.0521 9.79703 12.3023 9.54678L14.1608 7.68836C14.6714 7.17774 14.6714 6.34982 14.1608 5.8392C13.6501 5.32858 12.8222 5.32858 12.3116 5.8392Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.5016b311a66d7337939ce600e2c68f63.svg";
export { ForwardRef as ReactComponent };